module.exports = __webpack_public_path__ + "static/media/logo-complet.292165e5.png";